import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import Cookies from 'universal-cookie';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import { addAnalytics } from '../../Common/analytics';
import { MsalContext } from "@azure/msal-react";

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;
const cookies = new Cookies(window.document.cookies);
var port = window.location.port;

export default class TopbarProfile extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false,
      zoomLevel: 1,
      userName: "",
      TokenVal: ""
    };
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) === 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  deleteCookie(cname) {
    var d = new Date();
    d.setTime(d.getTime() - (1000 * 60 * 60 * 24));
    var expires = "expires=" + d.toGMTString();
    window.document.cookie = cname + "=" + "; " + expires;
  }

  componentWillMount() {
    var cookieUsername = this.getCookie('userName');
    var username = this.accessCookie("userName");
    var Token = this.getCookie('token');
    this.setState({
      userName: cookieUsername,
      TokenVal: Token
    });
    localStorage.setItem('userName', username);
  }

  componentDidMount() {
    this.detectZoom();
    window.addEventListener('resize', this.detectZoom);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.detectZoom);
  }

  detectZoom = () => {
    const zoom = window.devicePixelRatio || 1;
    this.setState({ zoomLevel: zoom });
  };

  handleLogout = (instance) => {
    const accounts = instance.getAllAccounts();
    this.deleteCookie('token');
    this.deleteCookie('selectedLocations');
    this.deleteCookie('userLocations');
    this.deleteCookie('userName');
    this.deleteCookie("userMenu")
    if (accounts.length > 0) {
      instance.logoutRedirect({
        account: instance.getActiveAccount(),
        postLogoutRedirectUri: window.location.origin,
        onRedirectNavigate: () => true, // optional, ensures redirect happens
      });
    }
    else{
      window.location.href = window.location.origin
    }
  };


  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  render() {
    const { collapse, zoomLevel } = this.state;
    let locationTextSize = "16px";
    let userNameMargin = '8%';

    if (zoomLevel >= 1.5) {
      locationTextSize = '12px';
      userNameMargin = '12%';
    } else if (zoomLevel >= 1.25) {
      locationTextSize = "14px";
      userNameMargin = '10%';
    }

    return (
      <MsalContext.Consumer>
        {({ instance }) => (
          <div className="topbar__profile">
            <button
              className="topbar__avatar"
              type="button"
              style={{ width: '100%' }}
              onClick={this.toggle}
            >
              <p
                className="topbar__avatar-name"
                style={{ marginTop: userNameMargin, fontSize: locationTextSize }}
              >
                {this.state.userName}
              </p>
              <img
                src={require("../../../images/logout.svg")}
                style={{ width: "18px", height: "18px", marginLeft: '12%', marginTop: userNameMargin }}
                alt="logout"
              />
            </button>

            {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}

            <Collapse isOpen={collapse} className="topbar__menu-wrap">
              <div className="topbar__menu">
                <TopbarMenuLink
                  title="Log Out"
                  icon="exit"
                  path=""
                  onClick={() => this.handleLogout(instance)}
                />
              </div>
            </Collapse>
          </div>
        )}
      </MsalContext.Consumer>
    );
  }
}
